/**
 * DrawingBlock - Container for a route/path.
 *
 * Parent: PlayBlock or ConceptBlock
 * Children: ControlPointBlock, PreSnapMarkerBlock
 * Path segments: Stored as block_references with reference_type='path_connection'
 *                connecting ControlPointBlocks (source = start point, target = end point)
 * Player link: block_references.player_link
 * Point link: block_references.point_link
 */

import type { BlockBase } from '../Base'
import type { DrawingProperties } from '@/types/BlockProperties'
import type { PlayBlock_Union } from '../Union'

/**
 * A drawing (route/path) on the canvas.
 * Contains control points that define the route.
 * Path connections between control points are stored in block_references table.
 */
export interface DrawingBlock extends BlockBase {
	type: 'drawing'
	properties: DrawingProperties
}

/**
 * Type guard for DrawingBlock.
 */
export function isDrawingBlock(block: PlayBlock_Union): block is DrawingBlock {
	return block.type === 'drawing'
}
